export default "__VITE_ASSET__2w3Szo9a__"